import { render, staticRenderFns } from "./tabChange.vue?vue&type=template&id=02064cec&"
import script from "./tabChange.vue?vue&type=script&lang=ts&"
export * from "./tabChange.vue?vue&type=script&lang=ts&"
import style0 from "./tabChange.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports